import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import norcatLogo from '../../assets/images/norcat-logo.png';
import backgroundFooter from '../../assets/images/backgrounds/background_footer.png';
import { navItems } from '../../Data/NavItems';
import NavSocials from '../Navs/NavSocials';
import { NewsletterForm } from "../Forms/Newsletter";
import BackToTopButton from './BackToTopButton';

const FOOTER_ROTATING_WORDS = [
    'experiences',
    'partnerships',
    'outcomes',
    'projects',
    'challenges',
    'solutions',
    'interactions',
    'products',
    'stories',
];

function Footer() {
    const [wordIndex, setWordIndex] = useState(0);
    const currentWord = FOOTER_ROTATING_WORDS[wordIndex];

    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setWordIndex((currentIndex) => (currentIndex + 1) % FOOTER_ROTATING_WORDS.length);
        }, 5000);

        return () => {
            window.clearInterval(intervalId);
        };
    }, []);

    return (
        <footer className="footer" style={{ position: 'relative', width: '100%' }}>
            <div
                className="footer--wrapper"
                style={{
                    backgroundImage: `url(${backgroundFooter})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'top center',
                    backgroundSize: 'cover',
                }}
            >
                <div className="container">
                    <div className="footer--header">
                        <h3 className="heading footer--header-title"><br/>
                            <span className="footer-heading-prefix">A studio driven by</span>{' '}
                            <span className="footer-heading-rotating-line">
                                <span className="footer-rotating-word" key={currentWord}>
                                    {currentWord}
                                </span>{' '}
                                that matter.
                            </span>
                        </h3>
                    </div>
                    <div className="footer--details">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="detail-single footer-phone-number">
                                    <h6>PHONE</h6>
                                    <a href="tel:17055218324">
                                        <h4>1 (705) 521 8324</h4>
                                    </a>
                                </div>
                                <div className="detail-single footer-address">
                                    <h6>ADDRESS</h6>
                                    <h4>
                                        1545 Maley Drive,<br />
                                        Sudbury, Ontario,<br />
                                        Canada
                                    </h4>
                                </div>
                                <div className="detail-single">
                                    <NewsletterForm />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="detail-single footer-email">
                                    <h6>CONTACT</h6>
                                    <a href="mailto:studio@norcat.org">
                                        <h4>studio@norcat.org</h4>
                                    </a>
                                </div>
                                <div className="detail-single">
                                    <NavSocials />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="detail-single footer-sitemap">
                                    <h6>SITEMAP</h6>
                                    <ul>
                                        {navItems.map((item) => (
                                            <li key={item.link}>
                                                <NavLink to={item.link}>{item.label}</NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <div className="footer-bottom-copy">
                            <div className="footer-bottom-logo">
                                <a href="https://norcat.org" target="_blank" rel="noreferrer">
                                    <img src={norcatLogo} alt="NORCAT logo" loading="lazy" decoding="async" />
                                </a>
                            </div>
                            <h6>Copyright (c) 2026 NORCAT. All Rights Reserved.</h6>
                        </div>
                        <BackToTopButton />
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
